import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { PiNotebookLight } from "react-icons/pi";
import { BiConversation } from "react-icons/bi";
import { FaMagnifyingGlass } from "react-icons/fa6";
import Header from "./Header";





export default function TaxHelp() {
  useEffect(() => {
    document.title = "The Only Consultant";
  }, []);

  return (
    <div className="w-full max-w-full sm:max-w-[500px] min-h-screen md:min-h-[550px] flex-col bg-pink-50 flex items-center mx-auto">
      <Header />
      <div className="w-full px-2 sm:px-4 py-3 sm:py-6">

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-1">
          {/* Income & Expense Tracker */}
          <Link
            to="/widget"
            className="rounded-md bg-[#f7adc4] text-white shadow transition hover:shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200"
          >
            <div className="flex flex-col items-center justify-center px-3 sm:px-4 py-4 sm:py-6 text-center">
              <h3 className="font-semibold text-base sm:text-lg md:text-[22px] leading-tight">
                Income and
                <br />
                Expense Tracker
              </h3>
              {/* Icon */}
              <div className="grid place-items-center mt-2">
                <LiaFileInvoiceDollarSolid className="w-10 h-10 sm:w-12 sm:h-12 md:w-[55px] md:h-[55px]" />
              </div>

              <p className="text-xs sm:text-sm md:text-[15px] mt-2 opacity-95">
                Track your finances in real time
              </p>
            </div>
          </Link>

          {/* Kink Income and Expense Tracker */}
          <Link
            to="/widget"
            className="rounded-md bg-[#f7adc4] text-white shadow transition hover:shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200"
          >
            <div className="flex flex-col items-center justify-center px-3 sm:px-4 py-4 sm:py-6 text-center">
              <h3 className="font-semibold text-base sm:text-lg md:text-[22px] leading-tight">
                Kink Income and
                <br />
                Expense Tracker
              </h3>
              {/* Icon */}
              <div className="grid place-items-center mt-2">
                <LiaFileInvoiceDollarSolid className="w-10 h-10 sm:w-12 sm:h-12 md:w-[55px] md:h-[55px]" />
              </div>

              <p className="text-xs sm:text-sm md:text-[15px] mt-2 opacity-95">
                Track your finances in real time
              </p>
            </div>
          </Link>

          {/* Creator Income and Expense Tracker */}
          <Link
            to="/widget"
            className="rounded-md bg-[#f7adc4] text-white shadow transition hover:shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200"
          >
            <div className="flex flex-col items-center justify-center px-3 sm:px-4 py-4 sm:py-6 text-center">
              <h3 className="font-semibold text-base sm:text-lg md:text-[22px] leading-tight">
                Creator Income and
                <br />
                Expense Tracker
              </h3>
              {/* Icon */}
              <div className="grid place-items-center mt-2">
                <LiaFileInvoiceDollarSolid className="w-10 h-10 sm:w-12 sm:h-12 md:w-[55px] md:h-[55px]" />
              </div>

              <p className="text-xs sm:text-sm md:text-[15px] mt-2 opacity-95">
                Track your finances in real time
              </p>
            </div>
          </Link>

          {/* Sugar Babies Income and Expense Tracker */}
          <Link
            to="/widget"
            className="rounded-md bg-[#f7adc4] text-white shadow transition hover:shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200"
          >
            <div className="flex flex-col items-center justify-center px-3 sm:px-4 py-4 sm:py-6 text-center">
              <h3 className="font-semibold text-base sm:text-lg md:text-[22px] leading-tight">
                Sugar Babies Income and
                <br />
                Expense Tracker
              </h3>
              {/* Icon */}
              <div className="grid place-items-center mt-2">
                <LiaFileInvoiceDollarSolid className="w-10 h-10 sm:w-12 sm:h-12 md:w-[55px] md:h-[55px]" />
              </div>

              <p className="text-xs sm:text-sm md:text-[15px] mt-2 opacity-95">
                Track your finances in real time
              </p>
            </div>
          </Link>

          {/* Write Off Guide */}
          <Link
            to="/guides"
            className="rounded-md bg-[#f7adc4] text-white shadow transition hover:shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200"
          >
            <div className="flex flex-col items-center justify-center px-3 sm:px-4 py-4 sm:py-6 text-center">
              <h3 className="font-semibold text-base sm:text-lg md:text-[22px] leading-tight">Write Off <br /> Guide</h3>
              <div className="grid place-items-center mt-2">
                <PiNotebookLight className="w-12 h-12 sm:w-14 sm:h-14 md:w-[65px] md:h-[65px]" />
              </div>
              <p className="text-xs sm:text-sm md:text-[15px] mt-2 opacity-95">See what you can claim</p>
            </div>
          </Link>
        </div>

        {/* Resources - Big Button at Bottom */}
        <div className="mt-4 sm:mt-6">
          <Link
            to="/resources"
            className="block rounded-md bg-[#f7adc4] text-white shadow transition hover:shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200"
          >
            <div className="flex flex-col items-center justify-center px-4 sm:px-6 py-6 sm:py-8 text-center">
              <h3 className="font-semibold text-lg sm:text-xl md:text-[24px] leading-tight mb-2">Resources</h3>
              <div className="grid place-items-center mb-2">
                <FaMagnifyingGlass className="w-12 h-12 sm:w-14 sm:h-14 md:w-[65px] md:h-[65px]" />
              </div>
              <p className="text-sm sm:text-base md:text-[16px] opacity-95">Explore tax tools and tips</p>
            </div>
          </Link>
        </div>
      </div>

      {/* Footer */}
      <div className="w-full bg-[#f7adc4] text-white text-center flex justify-center items-center px-4 py-2 mt-auto">
        <img src="/1.png" alt="Logo" className="h-auto w-16 sm:w-20" />
      </div>
    </div>
  );
}
